module.exports = __webpack_public_path__ + "2931271b4c187662bc739d6f8a9d5018.svg";